export async function getAnalyticsV4TrackingParameters() {
  if (!window?.magix) return {};

  const gAnalytics4 = window.magix['google-analytics-4'];

  if (!gAnalytics4) return {};

  const marketing = { analytics_measurement_id_v4: gAnalytics4 };

  if (typeof gtag === 'undefined') {
    return marketing;
  }

  const { clientId, sessionId, clickId } = await getAnalyticsV4Ids(gAnalytics4);

  return {
    ...marketing,
    ...(clientId ? { analytics_client_id_v4: clientId } : null),
    ...(sessionId ? { analytics_session_id_v4: sessionId } : null),
    ...(clickId ? { analytics_click_id_v4: clickId } : null),
  };
}

async function getAnalyticsV4Ids(measurementId) {
  return new Promise((resolve, _reject) => {
    const timeout = setTimeout(() => {
      resolve({});
    }, 3000);

    const marketingPromises = ['client_id', 'session_id'].map((id) => {
      return new Promise((resolve) => {
        gtag('get', measurementId, id, (value) => {
          resolve(value);
        });
      });
    });

    Promise.allSettled(marketingPromises).then(([client, session]) => {
      clearTimeout(timeout);
      resolve({
        clientId: client.status === 'fulfilled' ? client.value : null,
        sessionId: session.status === 'fulfilled' ? session.value : null,
        clickId: new URLSearchParams(window.location.search).get('gclid'),
      });
    });
  });
}
